export const listConstants = ({
  handleClickChangePassword,
  handleClickLogOut,
  handleClickUserManagement,
}: {
  handleClickChangePassword: CallableFunction;
  handleClickLogOut: CallableFunction;
  handleClickUserManagement: CallableFunction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}): any => {
  return [
    {
      label: 'User Management',
      iconName: 'users',
      onClick: handleClickUserManagement,
      alt: 'user',
    },
    {
      label: 'Change Password',
      iconName: 'lock',
      onClick: handleClickChangePassword,
      alt: 'change-password',
    },
    {
      label: 'Log Out',
      iconName: 'logout',
      onClick: handleClickLogOut,
      alt: 'logout',
    },
  ];
};
